import "../Customers/customers.css";
import { Breadcrumb, Col, Row } from "antd";
import { useNavigate } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { Link } from "react-router-dom";
import { getSuppliers } from "../../api/supplier";
import { getContactTypes } from "../../api/contactType";
import { getCurrencyDropdown } from "../../api/currency";
import { getCountriesDropdown } from "../../api/countries";
import { SuppliersList } from "./SuppliersLists";
import Title from "../UI/Title/Title";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { FilterInput } from "../UI/FilterApi/filterapi";
import { Pagination } from "./types";

function Suppliers() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [suppliers, setSuppliers] = useState<any>();
  const [tableKey, setTableKey] = useState("");
  const [formatedCurrency, setFormatedCurrency] = useState<{}[]>();
  const [formatedCountry, setFormatedCountry] = useState<[]>();
  const [formatedContactType, setFormatedContactType] = useState<{}[]>();
  const [initialValues, setInitialValues] = useState({ active: undefined });

  const [pagination, setPagination] = useState<Pagination>({
    current: 1,
    pageSize: 10,
    total: 0,
    limit: 10,
  });

  const { mutateAsync: getSuppliersMutation, isLoading: isSupplierLoading } =
    useMutation("suppliers", getSuppliers);

  const { isLoading: loadingContactType } = useQuery(
    "contactTypes",
    getContactTypes,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedContactType(
          res.data.map((contactType: any) => {
            return { value: contactType.id, label: contactType.typeName };
          })
        );
      },
    }
  );

  const { isLoading: loadingCurrency } = useQuery(
    "currencies",
    getCurrencyDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCurrency(
          res.data
            .map((currency: any) => {
              if (currency.isActive) {
                return { value: currency.id, label: currency.name };
              } else {
                return null;
              }
            })
            .filter((currency: any) => currency !== null)
        );

        if (res.data.length > 0) {
          setInitialValues({ active: res.data[0].id });
        }
      },
    }
  );

  const { isLoading: loadingCountry } = useQuery(
    "countries",
    getCountriesDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCountry(
          res.data
            ?.map((country: any) => {
              if (country.isActive) {
                return { value: country.id, label: country.name };
              } else {
                return null;
              }
            })
            .filter((country: any) => country !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ active: res.data[0].id });
        }
      },
    }
  );

  const handleReset = async () => {
    if (!search && filter === undefined) return
    setPagination(prevPagination => ({
      ...prevPagination,
      current: 1
    }))
    setSearch("");
    setFilter(undefined);
    setTableKey((tableKey) => tableKey + 1);
    const { data } = await getSuppliersMutation({})
    setSuppliers(data?.data);
  };

  const handleSearch = async () => {
    const { data } = await getSuppliersMutation({
      q: search,
      limit: pagination.limit,
      offset: (pagination.current - 1) * pagination.pageSize,
      isActive: filter
    })
    setSuppliers(data?.data);
  };

  const handleFilter = async (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    const { data } = await getSuppliersMutation({
      q: search,
      limit: pagination.limit,
      offset: (pagination.current - 1) * pagination.pageSize,
      isActive: isActive
    })
    setSuppliers(data?.data);
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col
          offset={1}
          span={22}
          style={{
            marginBottom: "10px",
          }}
        >
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {" "}
                    {t("suppliers-list")}{" "}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("suppliers-list")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={handleSearch}
          />
        </Col>

        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={handleReset}
            />
          </Col>
          <AddButton
            onClick={() => {
              navigate(`/suppliers/create`, {
                state: {
                  initialValues: initialValues,
                  loadingCountry: loadingCountry,
                  formatedCountry: formatedCountry,
                  formatedCurrency: formatedCurrency,
                  loadingCurrency: loadingCurrency,
                  formatedContactType: formatedContactType,
                  loadingCopntactType: loadingContactType,
                },
              });
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <SuppliersList
            suppliers={suppliers}
            setSuppliers={setSuppliers}
            isSupplierLoading={isSupplierLoading}
            getSuppliersMutation={getSuppliersMutation}
            pagination={pagination}
            setPagination={setPagination}
            filter={filter}
            search={search}
            tableKey={tableKey}
            setTableKey={setTableKey}
          />
        </Col>
      </Row>
    </>
  );
}

export default Suppliers;
